import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * MarketFilter Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Fetch config params
     */
    @Prop() fetchParams!: object;

    /**
     * Just show Parent categories in categories List
     */
    @Prop({ type: Boolean }) parentCategory!: boolean;
}
